'use strict';
/* KONO Hydrate page script (Shopify version of source/app.js).
   - Live product data from the store's Ajax Product API (not the preview's product.json snapshot).
   - Real multi-item cart form: one item per selected box; monthly selling plan only when subscribing.
   - Fails closed: checkout stays disabled with a visible message if the product, a variant or the
     monthly plan is missing or unavailable.
   - Each feature runs only if its section is on the page. */
(async () => {
  const $ = s => document.querySelector(s), $$ = s => [...document.querySelectorAll(s)];
  const json = id => { try { return JSON.parse(($(id) || {}).textContent || '{}'); } catch (e) { return {}; } };
  const cfg = json('#hydrate-config'), A = json('#hydrate-assets');
  const monthly = Number(cfg.monthlyPlan || 2307260494), pack = cfg.pack || '30 Stick Packs';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || cfg.root || '/';
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || cfg.currency || 'USD';
  let fmt; try { fmt = new Intl.NumberFormat(cfg.locale || document.documentElement.lang || 'en-US', { style: 'currency', currency }); } catch (e) { fmt = null; }
  const money = n => fmt ? fmt.format(n / 100) : '$' + (n / 100).toFixed(2);
  const photo = f => A['sticks-' + f.toLowerCase() + (f === 'Citrus' ? '.png' : '.jpg')] || '';
  const label = f => A['label-' + f.toLowerCase() + '.jpg'] || '';

  /* ---------- Buy box ---------- */
  const btn = $('#checkout'), form = $('#cart-form'), err = $('#cart-error'), hasBuy = !!(btn && form && $('#purchase-options'));
  let product = null, valid = false, submitting = false, cartItems = [];
  let flavor = 'Strawberry', second = 'Strawberry', quantity = 1, plan = 'sub', galleryMode = 'product';

  const setError = msg => {
    valid = false;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); if (msg && !submitting) btn.textContent = 'UNAVAILABLE'; }
    if (err) { err.hidden = !msg; err.textContent = msg || ''; }
  };
  const text = (sel, t) => { const el = $(sel); if (el) el.textContent = t; };

  if (hasBuy) {
    try {
      const r = await fetch(root + 'products/' + (cfg.handle || 'hydrate') + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      product = await r.json();
    } catch (e) {
      console.error('[Hydrate] product load failed', e);
      setError('We couldn’t load Hydrate right now. Please refresh the page or try again in a moment.');
    }
  }

  const variant = f => product && (product.variants || []).find(v =>
    (v.option1 === f && v.option2 === pack) || ((v.options || []).includes(f) && (v.options || []).includes(pack)));

  function update() {
    if (!hasBuy) return;
    const flavors = quantity === 2 ? [flavor, second] : [flavor];
    // selection UI first, so it always reflects the shopper's choice
    $$('[data-f]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.f === flavor)));
    $$('[data-second]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.second === second)));
    $$('[data-qty]').forEach(x => x.setAttribute('aria-pressed', String(+x.dataset.qty === quantity)));
    const mix = $('#mix-options'); if (mix) mix.hidden = quantity !== 2;
    const sel = $('#selected-image');
    if (sel && galleryMode === 'product' && photo(flavor)) { sel.src = photo(flavor); sel.alt = flavor + ' KONO Hydrate 30 stick packs'; }
    const pt = $('#product-thumb img'); if (pt && photo(flavor)) pt.src = photo(flavor);
    $$('.plan').forEach(x => { const i = x.querySelector('input'); x.classList.toggle('selected', !!(i && i.checked)); });
    if (!product) return;

    // validate live data before anything can be submitted
    const items = [];
    for (const f of flavors) {
      const v = variant(f);
      if (!v) return setError(f + ' isn’t available right now. Please choose another flavor.');
      if (!v.available) return setError(f + ' is sold out right now. Please choose another flavor or check back soon.');
      const a = (v.selling_plan_allocations || []).find(a => Number(a.selling_plan_id) === monthly);
      if (plan === 'sub' && !a) return setError('The monthly subscription isn’t available for ' + f + ' right now. Choose a one-time purchase instead.');
      items.push({ v, unit: plan === 'sub' ? a.price : v.price, sub: a ? a.price : v.price });
    }
    const total = items.reduce((s, i) => s + i.unit, 0), regular = items.reduce((s, i) => s + i.v.price, 0);

    text('#sub-price', money(items.reduce((s, i) => s + i.sub, 0)));
    text('#once-price', money(regular));
    text('#total-price', money(total));
    $$('[data-supply]').forEach(x => x.textContent = money(items[0].unit * +x.dataset.supply));
    const ss = $('#sticky-selection'); if (ss && ss.firstChild) ss.firstChild.textContent = flavors.join(' + ') + ' · ' + quantity + ' × 30 stick packs';
    text('#sticky-price', money(total) + (plan === 'sub' ? ' · Monthly subscription' : ' · One-time'));
    text('#savings', plan === 'sub' ? 'Save ' + money(regular - total) + ' per delivery' : 'No subscription');
    const rec = $('#recurring');
    if (rec) { rec.hidden = plan !== 'sub'; rec.textContent = money(total) + ' charged every month until canceled. Pause, skip or cancel anytime through your subscription account.'; }

    // rebuild the cart inputs: one item per selected box; selling_plan only when subscribing
    cartItems = items.map(({ v }) => plan === 'sub' ? { id: v.id, quantity: 1, selling_plan: monthly } : { id: v.id, quantity: 1 });
    form.querySelectorAll('input[type=hidden]').forEach(x => x.remove());
    const add = (name, value) => { const el = document.createElement('input'); el.type = 'hidden'; el.name = name; el.value = value; form.insertBefore(el, btn); };
    items.forEach(({ v }, i) => {
      add(`items[${i}][id]`, v.id);
      add(`items[${i}][quantity]`, 1);
      if (plan === 'sub') add(`items[${i}][selling_plan]`, monthly);
    });
    add('return_to', '/checkout');

    valid = true;
    if (err) { err.hidden = true; err.textContent = ''; }
    if (!submitting) { btn.disabled = false; btn.removeAttribute('aria-disabled'); btn.textContent = 'CONTINUE TO CHECKOUT · ' + money(total) + ' →'; }
    Object.assign(btn.dataset, { variant: items.map(i => i.v.id).join(','), plan, total: String(total) });
    window.hydrateSelection = { flavor, second, quantity, plan, items: items.map(i => i.v.id), total };
  }

  if (hasBuy) {
    // Add through Shopify's cart API, then go straight to checkout.
    // The button is turned into a plain button (no form submission), so cart-drawer / upsell apps that
    // intercept "add to cart" form submits never see one. Any submit of this form is also caught at the
    // window level, before any app listener, and stopped there.
    async function addAndCheckout() {
      if (!valid || submitting || !cartItems.length) return;
      submitting = true; btn.disabled = true; btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'ADDING TO CART…';
      if (err) { err.hidden = true; err.textContent = ''; }
      try {
        const r = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: cartItems })
        });
        const data = await r.json().catch(() => ({}));
        if (!r.ok) throw new Error(data.description || data.message || 'We couldn’t add Hydrate to your cart.');
        btn.textContent = 'GOING TO CHECKOUT…';
        window.location.assign(root + 'checkout');
      } catch (ex) {
        console.error('[Hydrate] add to cart failed', ex);
        submitting = false;
        update();
        if (err) { err.hidden = false; err.textContent = ex.message + ' Please try again.'; }
      }
    }
    btn.type = 'button';
    btn.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); addAndCheckout(); });
    window.addEventListener('submit', e => {
      if (e.target !== form) return;
      e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); addAndCheckout();
    }, true);
    // back/forward cache: re-enable the button if the shopper returns to the page
    window.addEventListener('pageshow', () => { submitting = false; update(); });
  }

  const thumb = b => $$('#product-thumb,[data-scene]').forEach(x => { x.classList.toggle('active', x === b); x.setAttribute('aria-pressed', String(x === b)); });
  $$('[data-f],[data-qty],[data-flavor],[data-second]').forEach(x => x.addEventListener('click', e => {
    if (x.tagName === 'BUTTON' && x.closest('form')) e.preventDefault();
    if (x.dataset.f || x.dataset.flavor) { flavor = x.dataset.f || x.dataset.flavor; if (quantity === 1) second = flavor; galleryMode = 'product'; const pt = $('#product-thumb'); if (pt) thumb(pt); }
    if (x.dataset.qty) quantity = +x.dataset.qty;
    if (x.dataset.second) second = x.dataset.second;
    update();
    if (x.dataset.flavor) { const po = $('#purchase-options'); if (po) po.scrollIntoView({ behavior: 'smooth' }); }
  }));
  $$('input[name=plan]').forEach(x => x.addEventListener('change', () => { plan = x.value; update(); }));
  const ptb = $('#product-thumb');
  if (ptb) ptb.addEventListener('click', () => { galleryMode = 'product'; thumb(ptb); update(); });
  $$('[data-scene]').forEach(x => x.addEventListener('click', () => {
    galleryMode = 'scene'; thumb(x);
    const sel = $('#selected-image'); if (sel) { sel.src = x.dataset.scene; sel.alt = (x.getAttribute('aria-label') || '').replace('Show ', ''); }
  }));

  /* ---------- Nutrition labels and lab results ---------- */
  $$('[data-label]').forEach(x => x.addEventListener('click', () => {
    const d = $('#label-dialog'); if (!d) return; const f = x.dataset.label;
    const img = $('#label-image'); if (img) { img.src = label(f); img.alt = f + ' KONO Hydrate nutrition and ingredients'; }
    text('#label-title', f + ' · Nutrition & Ingredients');
    d.showModal();
  }));
  ['label-dialog', 'lab-dialog'].forEach(id => { const d = $('#' + id); if (d) d.addEventListener('click', e => { if (e.target === e.currentTarget) e.currentTarget.close(); }); });
  $$('[data-lab]').forEach(x => x.addEventListener('click', () => {
    const d = $('#lab-dialog'), f = $('#lab-frame'); if (!d) return;
    if (f && !f.getAttribute('src')) f.src = f.dataset.source; d.showModal();
  }));

  /* ---------- Sticky selection bar ---------- */
  const stickyEl = $('.sticky');
  function sticky() {
    const card = $('#purchase-card'), foot = document.querySelector('footer');
    if (!stickyEl || !card) { if (stickyEl) stickyEl.hidden = true; return; }
    stickyEl.hidden = card.getBoundingClientRect().bottom > 0 || (foot && foot.getBoundingClientRect().top < innerHeight);
  }
  addEventListener('scroll', sticky, { passive: true }); addEventListener('resize', sticky);

  update(); sticky();
  window.hydrateReady = true;

  /* ---------- Fallback review list (never blocks the live Judge.me widget) ---------- */
  const list = $('#sourced-reviews');
  if (list && A['reviews.json']) {
    try {
      const reviews = await fetch(A['reviews.json']).then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
      const sortEl = $('#review-sort'), filterEl = $('#review-filter');
      const render = () => {
        let rows = reviews.filter(r => !filterEl || filterEl.value === 'all' || String(r.rating) === filterEl.value);
        if (sortEl && sortEl.value !== 'recent') rows.sort((a, b) => sortEl.value === 'high' ? +b.rating - +a.rating : +a.rating - +b.rating);
        list.replaceChildren(...rows.map(r => {
          const q = document.createElement('blockquote'), s = document.createElement('div'), t = document.createElement('strong'), p = document.createElement('p'), c = document.createElement('cite');
          s.textContent = '★'.repeat(+r.rating); s.setAttribute('aria-label', r.rating + ' out of 5 stars');
          t.textContent = r.title; p.textContent = r.body; c.textContent = r.name + ' · ' + r.date;
          q.append(s, t, p, c); return q;
        }));
        text('#review-status', rows.length ? 'Showing ' + rows.length + ' recent sourced reviews.' : 'No reviews with this rating in the recent sourced selection.');
      };
      if (sortEl) sortEl.addEventListener('change', render);
      if (filterEl) filterEl.addEventListener('change', render);
      render();
    } catch (e) { console.warn('[Hydrate] fallback reviews unavailable', e); }
  }
  window.hydrateReviewsReady = true;
})().catch(e => { console.error(e); window.hydrateError = e.message; });

/* Keep Judge.me widget links on this page, including content loaded by its sorting/pagination. */
(() => {
  const root = document.querySelector('#judgeme_product_reviews');
  if (!root) return;
  // Judge.me hides the widget with a temporary style until its own setup finishes. On this page that
  // style can be left behind, keeping the reviews hidden: remove it once the widget is set up
  // (or after 4 seconds as a safety net, so real reviews never stay hidden).
  const reveal = () => root.querySelectorAll('style.jdgm-temp-hiding-style').forEach(el => el.remove());
  setTimeout(reveal, 4000);
  function local() {
    if (root.classList.contains('jdgm--done-setup-widget')) reveal();
    root.querySelectorAll('.jdgm-form-wrapper,.jdgm-write-rev-link').forEach(el => el.remove());
    document.querySelectorAll('a.jdgm-random-link[href="#"]').forEach(a => a.setAttribute('href', '#judgeme_product_reviews'));
    root.querySelectorAll('img[data-src]:not([src])').forEach(img => { img.src = img.dataset.src; });
    root.querySelectorAll('a[href="#"]').forEach(a => a.setAttribute('href', '#judgeme_product_reviews'));
    root.querySelectorAll('a[href]').forEach(a => {
      if (/(?:\/products\/hydrate|judge\.me\/reviews\/stores\/[^/]+\/products\/hydrate)/.test(a.getAttribute('href'))) { a.setAttribute('href', '#judgeme_product_reviews'); a.removeAttribute('target'); }
    });
  }
  new MutationObserver(local).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'src', 'data-src', 'class'] });
  local();
})();
